import api from '../../../lib/api'

export interface AuditLogItem {
  id: number
  lead_id: number | null
  action: string
  entity_type: string | null
  entity_id: string | null
  actor: string
  changes: Record<string, unknown> | null
  timestamp: string | null
}

export interface AuditLogsResponse {
  page: number
  page_size: number
  items: AuditLogItem[]
}

export interface LeadLifecycleEvent {
  id: number
  action: string
  actor: string
  changes: Record<string, unknown> | null
  timestamp: string | null
}

export interface LeadLifecycleResponse {
  lead_id: number
  total_events: number
  events: LeadLifecycleEvent[]
}

export interface LeadTrailEntry {
  id: number
  action: string
  changes: Record<string, unknown> | null
  timestamp: string | null
  current_hash: string | null
  previous_hash: string | null
  hash_verified: boolean | null
}

export interface LeadTrailResponse {
  lead_id: number
  chain_intact: boolean
  total_events: number
  entries: LeadTrailEntry[]
}

export interface ChainVerifyResponse {
  tenant_id: number
  total_records: number
  chain_intact: boolean
  first_broken_at_log_id: number | null
  failure_count: number
  failures: Array<{ log_id: number; issue: string }>
  verified_at: string
}

export const auditService = {
  async getLogs(params: {
    lead_id?: number
    action?: string
    from_date?: string
    to_date?: string
    page?: number
    page_size?: number
  }): Promise<AuditLogsResponse> {
    const { data } = await api.get('/audit/logs', { params })
    return data
  },

  async getLeadLifecycle(leadId: number): Promise<LeadLifecycleResponse> {
    const { data } = await api.get(`/audit/leads/${leadId}/lifecycle`)
    return data
  },

  async getLeadTrail(leadId: number): Promise<LeadTrailResponse> {
    const { data } = await api.get(`/audit/leads/${leadId}/trail`)
    return data
  },

  async verifyChain(): Promise<ChainVerifyResponse> {
    const { data } = await api.get('/audit/chain/verify')
    return data
  },

  async getPlatformLogs(params: {
    tenant_id?: number
    entity_type?: string
    action?: string
    page?: number
    page_size?: number
  }): Promise<AuditLogsResponse> {
    const { data } = await api.get('/audit/platform', { params })
    // Normalise to the same shape as AuditLogsResponse
    return data
  },
}
